let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("16Kr3")).then(() => parcelRequire('7D0E8'));